<template>
  <div class="flex flex-col p-8 w-auto max-w-[430px] md:max-w-[1440px]" :class="themeStyle">
    <hr class="border-black">
    <div class="flex flex-row justify-between my-[32px] text-4xl lg:text-6xl">
      <h2>FAQ</h2>
      <Icon
        :icon="isExpanded ? 'minus' : 'plus'"
        role="button"
        tabindex="0"
        @click="toggleExpanded"
        @keydown.enter.space="toggleExpanded"
       
        aria-controls="faq-panel"
        :aria-disabled="lockedExpanded ? 'true' : 'false'"
        :aria-label="isExpanded ? 'FAQ Expanded' : 'FAQ Collapsed'"
      />
    </div>

    <div
      id="faq-panel"
      class="flex-row flex-wrap justify-between"
      :class="isExpanded ? 'flex' : 'hidden'"
    >
      <div v-for="faq in props.faqs" :key="faq.question" class="mb-[32px] flex-initial basis-full md:basis-[45%]">
        <h3 :id="'faq-q-' + faq.question" class="text-2xl font-bold mb-[32px]" :aria-describedby="'faq-a-' + faq.question">{{ faq.question }}</h3>
        <p :id="'faq-a-' + faq.question"  class="text-xl">{{ faq.answer }}</p>
      </div>
    </div>
    <hr class="border-black">
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import Icon from "../atom/icon.vue";

interface Faq {
  question: string;
  answer: string;
}

interface Faqs {
  theme: "DARK" | "LIGHT";
  faqs: Faq[];
}

const props = defineProps<Faqs>();

const textColor = () => props.theme === "DARK" ? "text-white" : "text-black";
const backgroundColor = () => props.theme === "DARK" ? "bg-black" : "bg-white";
const height = () => isExpanded.value ? 'h-auto' : 'h-[138px] lg:h-[268px]';

const themeStyle = computed(() => `${backgroundColor()} ${textColor()} ${height()}`);

const isExpanded = ref(false);
const lockedExpanded = ref(false);

const toggleExpanded = () => {
  if (!lockedExpanded.value) {
    isExpanded.value = !isExpanded.value;
  }
};
</script>
